import { render, staticRenderFns } from "./TableVideoRequestsUser.vue?vue&type=template&id=473d6c42"
import script from "./TableVideoRequestsUser.js?vue&type=script&lang=js&external"
export * from "./TableVideoRequestsUser.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports